// extracted by mini-css-extract-plugin
export default {"root":"DashboardScreen_root__X+Igh"};